export const OPTIONS_VALUE_BY_FORMAT = {
  Yes: true,
  No: false,
  On: true,
  Off: false,
  True: true,
  False: false
};
